import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Cookies from 'universal-cookie';
import { useHistory } from 'react-router-dom';
import {
  Container,
  FormWrap,
  FormContent,
  Form,
  FormInput,
  FormLabel,
  FormButton,
  FormCardWrapper,
  FormDiv,
  FormH1,
} from './VoucherElements';
import {
  ErrorCard,
  MessageH1,
  MessageH2,
} from './MessageElements';
import SuccessModal from '../Modal/Sukses';
import { animateScroll as scroll } from 'react-scroll';

const KlaimVoucher = ({ userData }) => {
  const [data, setData] = useState({ code: '', nominal: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [nama, setNama] = useState('');
  const [showModal, setShowModal] = useState(false);

  const history = useHistory();
  const cookies = new Cookies();
  const token = cookies.get('token');

  useEffect(() => {
    if (userData?.username) {
      fetchData();
    }
  }, [userData.username]);

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/ppip/peserta/${userData.username}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const fetchedData = response.data.content?.[0];
      if (fetchedData) {
        setNama(fetchedData.nama_lengkap || '');
      }
    } catch (error) {
      console.error(error?.response?.data?.message || error.message);
    }
  };

  const handleChange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value.trimStart(),
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Validasi manual di frontend
    if (!data.code) {
      setError('Kode voucher wajib diisi!');
      setLoading(false);
      return;
    }

    if (!data.nominal || isNaN(data.nominal) || Number(data.nominal) <= 0) {
      setError('Nominal harus berupa angka lebih dari 50000!');
      setLoading(false);
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/voucher/${userData.username}`,
        {
          code: data.code.trim(),
          nominal: Number(data.nominal),
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setSuccess('Data berhasil disimpan dan akan segera kami proses. Mohon dapat dicek secara berkala.');
      setShowModal(true);
      setError('');
    } catch (error) {
      const errMsg = error?.response?.data?.message || 'Terjadi kesalahan. Silakan coba lagi.';
      setError(errMsg);
      setTimeout(() => setError(''), 3000);
      setSuccess('');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <FormWrap>
        <FormContent>
          <Form onSubmit={handleSubmit}>
            <FormH1>Klaim Voucher</FormH1>
            <FormCardWrapper>
              <FormDiv>
                <FormLabel htmlFor="no_peserta">Nomor Peserta</FormLabel>
                <FormInput type='text' name='no_peserta' value={userData.username} readOnly />
                <FormLabel htmlFor="nama">Nama</FormLabel>
                <FormInput type='text' name='nama' value={nama} readOnly />
              </FormDiv>
              <FormDiv>
                <FormLabel htmlFor="code">Kode Voucher</FormLabel>
                <FormInput type='text' name='code' value={data.code} onChange={handleChange} />
                <FormLabel htmlFor="nominal">Nominal</FormLabel>
                <FormInput type='text' name='nominal' value={data.nominal} onChange={handleChange} />
              </FormDiv>
            </FormCardWrapper>
            <FormDiv>
              {error && (
                <ErrorCard>
                  <MessageH1><b>Gagal!</b></MessageH1>
                  <MessageH2>{error}</MessageH2>
                </ErrorCard>
              )}
              {success && (
                <SuccessModal
                  show={showModal}
                  onLogin={() => {
                    setShowModal(false);
                    history.push('/peserta/profil/');
                    scroll.scrollToTop();
                  }}
                  message={success}
                />
              )}
              <FormButton type="submit" disabled={loading}>
                {loading ? 'Loading...' : 'Simpan'}
              </FormButton>
            </FormDiv>
          </Form>
        </FormContent>
      </FormWrap>
    </Container>
  );
};

export default KlaimVoucher;
